import { useCreatorCashContext } from '../../../context/CreatorCashProvider';
import FadeInSection from '../../FadeInComponent/FadeInComponent';
import ApplyNow from '../ApplyNow/ApplyNow';
import './CompareYourOptions.css';

export default function CompareYourOptions({ scrollToRef }) {
    const { state } = useCreatorCashContext();
    const compareYourOptions = state?.compareYourOptions;
    const tableContent = compareYourOptions?.tableContent;

    return (
        <div className="compare-your-options-container">
            <div className="compare-your-options-wrapper">
                <FadeInSection className="cyo-header">
                    {compareYourOptions?.title}
                </FadeInSection>
                <FadeInSection className='cyo-content'>
                    <table className='cyo-table'>
                        <tr className='cyo-table-header'>
                            <th></th>
                            {
                                tableContent?.tableHead?.map((thead, index) => <th key={index}>{thead}</th>)
                            }
                        </tr>
                        <tbody>
                            {
                                Object.keys(tableContent?.tableData)?.map((key, index) => (
                                    <tr key={index}>
                                        <td>{key}</td>
                                        <td>{tableContent?.tableData[key][0]}</td>
                                        <td>{tableContent?.tableData[key][1]}</td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                    <div className="cyo-footer">
                        <div className='cyo-sub-title'>{compareYourOptions?.subTitle}</div>
                        {compareYourOptions?.showApplyNowButton && <ApplyNow label={"Check Eligibility"} className={"cyo-apply-now"} onClick={scrollToRef} />}
                    </div>
                </FadeInSection>
            </div>
        </div>
    )
}